import { Col, Form, Row } from "reactstrap";
import { dynamicImage } from "../../../../../utils";
import { Image } from "../../../../../coreComponents/Image";

// This component displays the footer of the invoice. It includes a thank you message and a note.
const InvoiceFooter = () => {
  return (
    <Row>
      <Col md="8">
        <div>
          <p>
            <strong>Thank you for your business!</strong>&nbsp; Payment is expected within 31 days; Please process this invoice within that time. There will be a 5% interest charge per month on late invoices.
          </p>
        </div>
      </Col>
      <Col md="4">
        <Form className="text-end">
          <Image src={dynamicImage(`other-images/paypal.png`)} alt="PayPal" />
        </Form>
      </Col>
    </Row>
  );
};

export default InvoiceFooter;
